import React from 'react'
import { useStyles } from '../style'
import { Box, Typography } from '@mui/material'
import { ReactComponent as IllustrationSvg } from './illustration.svg'

const Error = () => {
  const classes = useStyles()

  return (
    <>
      <Typography className={classes.heading}>
        Sorry, we are unable to verify your email
      </Typography>
      <Box className={classes.containerContent}>
        <Typography className={classes.subtitle2}>
          Please follow the confirmation link from your email or try again
          later.
        </Typography>

        <Box className={classes.illustration}>
          <IllustrationSvg />
        </Box>
      </Box>
    </>
  )
}

export default Error
